export default function initLineItem() {
  Alpine.data('lineItem', (sku: string, gtin: string, stock: number, price: string) => ({
    sku,
    gtin,
    stock,
    price,
    gtmProductCartPushEvent(event: string) {
      if (window.ccc && window.ccc['default-statistics'] && window.DATALAYER) {
        const gtmProduct = {
          sku: this.sku,
          gtin: this.gtin,
          stock: this.stock,
          price: parseFloat(this.price),
        };
        const ecommerceObj = {
          currencyCode: window.CRAFT_COMMERCE_CURRENCY,
        };
        // @ts-ignore
        ecommerceObj[event] = {
          products: [gtmProduct],
        };

        window.DATALAYER.push({
          event: event === 'add' ? 'addToCart' : 'removeFromCart',
          ecommerce: ecommerceObj,
          eventTimeout: 2000,
        });
      }
    },
    qtyChange(event: Event, qty: number) {
      // @ts-ignore
      this.gtmProductCartPushEvent(event.target.value < qty ? 'remove' : 'add');
    },
  }));
}
